{"errno":-2,"code":"ENOENT","syscall":"open","path":"/tmp/tmp-1042612ZSL0F72zvMA/packages/auth/dist/[synthetic:es6/util/arrayiterator]"}